import Vue from 'vue'
import VueComponent from './SimplifiedGlobalHeader.vue'

new Vue({
  render: h => h(VueComponent),
}).$mount('#vue-component-simplifiedGlobalHeader')